import React, { useEffect, useState } from 'react';
import { css } from 'styled-components';
import { Events, animateScroll as scroll } from 'react-scroll';
import IconArrowUp from '../assets/IconArrowUp';
import useTheme from '../../utils/styles/theme/useTheme';

let ticking = false;

export default function ScrollToTop() {
  const { colors } = useTheme();
  const [showButton, setShowButton] = useState(false);

  function handleScroll() {
    const lastScrollY = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        // console.log(lastScrollY, showButton);
        if (lastScrollY > 500) {
          if (!showButton) setShowButton(true);
        } else {
          if (showButton) setShowButton(false);
        }
        ticking = false;
      });
      ticking = true;
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showButton]);
  return (
    <div
      onClick={() => scroll.scrollToTop()}
      css={css`
        position: fixed;
        bottom: 16px;
        right: 16px;
        cursor: pointer;
        background: ${({ theme: { colors } }) => colors.primary.primary};
        border: 1px solid ${({ theme: { colors } }) => colors.primary.neutral};
        border-radius: 50px;
        display: inline-block;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all ease-in-out 0.2s;
        opacity: ${showButton ? 1 : 0};
        :hover {
          background: ${({ theme: { colors } }) => colors.primary.secondary};
        }
      `}
    >
      <IconArrowUp width={30} height={30} fill={colors.light.primary} />
    </div>
  );
}
